// client/src/hooks/useWebChatSocket.js
// Socket del Canal Web (widget del visitante). Se conecta al namespace /web con el
// sessionToken emitido por POST /api/web/start y recibe los mensajes del bot/agente
// vía el evento 'new_message'. Espeja el patrón de useAgentSocket pero del lado del
// cliente final.
import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

const SOCKET_BASE = process.env.NODE_ENV === 'production'
  ? window.location.origin
  : 'http://localhost:5000';

export function useWebChatSocket(sessionToken, onNewMessage) {
  const socketRef = useRef(null);
  const handlerRef = useRef(onNewMessage);
  handlerRef.current = onNewMessage;

  useEffect(() => {
    if (!sessionToken) return undefined;
    const socket = io(`${SOCKET_BASE}/web`, { auth: { token: sessionToken } });
    socketRef.current = socket;
    socket.on('new_message', (data) => handlerRef.current?.(data));
    return () => socket.disconnect();
  }, [sessionToken]);

  return {
    sendMessage: (content, type = 'text', media_url = null) =>
      socketRef.current?.emit('web_message', { content, type, media_url }),
  };
}
